import React, { useContext, useEffect } from 'react';
import { StateContext, ChangeStateContext } from '../State';
import { useMessageGetter } from '@messageformat/react';
import { useCookies } from 'react-cookie';
import { Mode, RepMode } from '../constants';
import '../css/language-chooser.scss';
import { ModelContext } from '../ModelContext';
import { Button } from '@op/opds.opux';

const LANGUAGE_COOKIE_NAME = 'op.login.language';

const LanguageChooser = (props) => {
    const [, setCookie] = useCookies([LANGUAGE_COOKIE_NAME]);
    const state = useContext(StateContext);
    const changeState = useContext(ChangeStateContext);
    const messageGetter = useMessageGetter('fp');
    const { model } = useContext(ModelContext);

    const setLanguageCookie = (lang) => {
        setCookie(LANGUAGE_COOKIE_NAME, lang, { path: '/' });
    };

    const changeLanguage = (lang) => {
        changeState({ lang: lang });
        /* Auth-components login component handles cookie updating during login, but we have to do it ourselves during representation management. */
        if (state.mode !== Mode.LOGIN) {
            setLanguageCookie(lang);
        }
    };

    useEffect(() => {
        /* Use browser API to update localized page title and also html element lang attribute. */
        document.title = messageGetter('serviceName');
        document.documentElement.lang = state.lang;
        if (state.repMode === RepMode.CHANGE_REP_INIT) {
            /* Change representation lang URL parameter may have changed our language to differ from cookie value, so update it here. */
            console.debug('setting language cookie in change representation init:', state.lang);
            setLanguageCookie(state.lang);
        }
    });

    const allLanguages = [
        {
            id: 'en',
            selected: state.lang === 'en',
            description: messageGetter('languageName.en'),
        },
        {
            id: 'sv',
            selected: state.lang === 'sv',
            description: messageGetter('languageName.sv'),
        },
        {
            id: 'fi',
            selected: state.lang === 'fi',
            description: messageGetter('languageName.fi'),
        },
    ];

    /* Filter out languages not supported by this utilizer */
    const supportedLanguages = allLanguages.filter((lang) => model.supportedLanguages.includes(lang.id));

    const languageItems = supportedLanguages.map((lang) => (
        <React.Fragment key={lang.id}>
            {!lang.selected && (
                <Button compact id={'lang_' + lang.id} onClick={() => changeLanguage(lang.id)} className='lang-item' lang={lang.id}>
                    {lang.description}
                </Button>
            )}
        </React.Fragment>
    ));

    return <div className='language-chooser-select'>{languageItems}</div>;
};

export default LanguageChooser;
